<!--
@Author: MIYONGLE
@Desc: 移动端底部
@Date: 2021-07-26 14时
-->
<template>
  <div class="bottom-con">
    <!-- 下拉 -->
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item
        v-for="(item, index) in bottomBussinessConts"
        :key="index"
        :title="item.title"
      >
        <span
          v-for="(itemSon, indexSon) in item.children"
          :key="indexSon"
          @click="jumpPage(itemSon.path)"
        >
          {{ itemSon.title }}
        </span>
      </van-collapse-item>
    </van-collapse>

    <!-- 联系我们 -->
    <div class="contact-us-con">
      <span class="contact-us-title">联系我们</span>

      <!-- 地址 -->
      <div class="adress-con">
        <!-- 左边 -->
        <div class="adress-con-left">
          <span>400-085-5500</span>
          <span>market@hvyogo.com</span>
          <span>{{ compInfo.companyAddress }}</span>
        </div>
      </div>
    </div>

    <!-- 二维码 -->
    <div class="qr_code" v-if="!ismExtensionPage">
      <div>
        <img
          :class="[!!classNameChange ? '' : 'imgChangeNo']"
          src="../../static/mobile/footer_img_wechat.png"
          alt=""
        />
        <span>慧用工公众号</span>
      </div>
      <div>
        <!--  v-if="setting == 'production'" -->
        <img
          :class="[!!classNameChange ? '' : 'imgChangeNo']"
          src="../../static/mobile/footer_img_wechat_dl.png"
          alt=""
        />
        <!-- <img v-else src="../../static/mobile/test.png" alt=""/> -->
        <span>代理助手小程序</span>
      </div>
    </div>

    <!-- 备案号 -->
    <div class="copyright">
      <span>Copyright© {{ timeYear }}{{ compInfo.whichCompName }} </span>
      <div>
        <img src="../../static/pc/备案图标.png" />
        <span>{{ compInfo.policeText }}</span>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { NAV_BUSSINESS_CONTS } from ".././service/businessConsts";
import { changeJumpPageUrl } from "../filters/filters";

export default {
  name: "mMenusBottom",
  data() {
    return {
      activeNames: ["1"],
      bottomBussinessConts: NAV_BUSSINESS_CONTS,
      compInfo: {},
      timeYear: "",
      setting: "",
      classNameChange: false,
      ismExtensionPage: false // 移动端定制推广页特殊展示
    };
  },

  components: {},

  created() {
    let pathTemp = window.location.hash;
    let path = pathTemp.substring(1, pathTemp.length);
    if (path === "/mExtensionPage") {
      this.ismExtensionPage = true;
    }

    this.setting = process.env.NODE_ENV;
    this.timeYear = new Date().getFullYear();
    this.compInfo = this.getSiteAddress();
    let type = navigator.userAgent.toLowerCase();
    console.log(type, "??");
    if (type.match(/MicroMessenger/i) == "micromessenger") {
      this.classNameChange = true;
    } else {
      this.classNameChange = false;
    }
  },

  methods: {
    // 页面跳转
    jumpPage(url) {
      this.$router.push({
        path: changeJumpPageUrl(url)
      });
    }
  }
};
</script>

<style>
.bottom-con .van-collapse {
  background-color: #100f0f;
}
.bottom-con .van-cell {
  background-color: #100f0f;
  height: 87px;
  line-height: 87px;
  color: #cfcfcf;
  font-size: 28px;
  padding: 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #39424d;
  border-bottom: 1px solid #39424d;
}

.bottom-con .van-collapse-item {
  padding: 0 30px;
  box-sizing: border-box;
}

.bottom-con .van-collapse-item__content {
  background-color: #100f0f;
  font-size: 26px;
  text-align: left;
  color: #78818c;
  padding: 0;
}

.bottom-con .van-collapse-item__content span {
  display: block;
  padding: 24px 0;
}
.bottom-con .van-cell__left-icon,
.bottom-con .van-cell__right-icon {
  font-size: 40px;
  color: rgba(102, 109, 122, 1);
  margin-top: 30px;
}

.bottom-con .van-cell__title,
.van-cell__value {
  flex: initial;
}

.bottom-con .van-cell:not(:last-child)::after {
  border-bottom: none;
}

.bottom-con [class*="van-hairline"]::after {
  border-bottom: none;
  border: 0;
}
</style>

<style lang="scss" scoped>
.bottom-con {
  background: #100f0f;
  padding-top: 32px;
  padding-bottom: 160px;

  // 联系我们
  .contact-us-con {
    margin-top: 23px;
    padding: 0 30px;
    .contact-us-title {
      color: #cfcfcf;
      font-size: 28px;
      display: block;
      text-align: left;
    }

    //地址
    .adress-con {
      margin-top: 8px;
      display: flex;
      // justify-content: space-between;
      .adress-con-left {
        width: 100%;
        margin-top: 30px;
        span {
          text-align: left;
          display: block;
          color: #78818c;
          font-size: 28px;
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
        }

        span:nth-child(1)::before {
          width: 34px;
          height: 34px;
          content: " ";
          display: block;
          background: url("../../static/mobile/ic_home_phone.png") no-repeat
            center;
          background-size: 100%;
          margin-right: 8px;
          margin-top: 4px;
        }

        span:nth-child(2)::before {
          width: 36px;
          height: 36px;
          content: " ";
          display: block;
          background: url("../../static/mobile/ic_home_mail.png") no-repeat
            center;
          background-size: 100%;
          margin-right: 8px;
          margin-top: 4px;
        }

        span:nth-child(3)::before {
          width: 36px;
          height: 36px;
          content: " ";
          display: block;
          background: url("../../static/mobile/ic_home_address.png") no-repeat
            center;
          background-size: 100%;
          margin-right: 8px;
          margin-top: -2px;
        }
      }
    }
  }

  // 二维码
  .qr_code {
    margin-top: 37px;
    display: flex;
    justify-content: center;
    div {
      width: 234px;
      &:nth-child(1) {
        margin-right: 45px;
      }
      img {
        display: block;
        width: 100%;
        height: 234px;
      }
      span {
        display: block;
        margin-top: 17px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #78818c;
      }
    }
  }

  // 备案号
  .copyright {
    margin-top: 16px;
    font-size: 22px;
    padding-top: 16px;
    border-top: 1px solid #39424d;
    color: #78818c;
    padding-bottom: 19px;
    line-height: 33px;
    span {
      display: inline-block;
      color: #78818c;
    }
    img {
      position: relative;
      top: 4px;
    }
  }
}

.imgChangeNo {
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mMenusBottom.vue